import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioOrgInvitationsUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';
import type { PortfolioRole } from '@/lib/portfolio/types';

interface CreateInvitationParams {
  email: string;
  roleName: PortfolioRole;
}

export function useCreateInvitation(portfolioId: number, orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ email, roleName }: CreateInvitationParams) =>
      apiPost(portfolioOrgInvitationsUrl(portfolioId, orgId), {
        email,
        role_name: roleName,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgInvitations(portfolioId, orgId),
      });
    },
  });
}
